import { render, staticRenderFns } from "./TeamAttendanceStats.vue?vue&type=template&id=3455daf5&"
import script from "./TeamAttendanceStats.vue?vue&type=script&lang=ts&"
export * from "./TeamAttendanceStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports